import { MaintenanceForwardingsDirectiveEntryKlass } from "../../types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";

export const maintenanceForwardingsDirectiveEntryKlasses: Partial<{
  [K in MaintenanceForwardingsDirectiveEntryKlass]: {
    label: string;
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    label: 'Diagnóstico e Orçamento',
  }
}
